module.exports = __webpack_public_path__ + "04c61b63b8788e91a34283372a7a7783.MP3";